<template>
  <div class="app-wrapper">
    <div class="app-container vue-container">
      <LoadingOverlay v-if="this.isLoading"/>
      <router-view/>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {setBrandConfig} from "@/functions/setBrandConfig";
import {mapState, mapMutations} from "vuex";
import FantasyService from "@/services/fantasyService";

export default {
  computed: {
    ...mapState(['isLoading', 'defferedPrompt', 'brandConfig'])
  },
  components: {
    LoadingOverlay
  },
  methods: {
    ...mapMutations(['setDeferredPrompt', 'setIsLoading', 'setFeedArticles']),
    captureEvent() {
      window.addEventListener('beforeinstallprompt', (e) => {
        console.log("beforeinstallprompt fired -> ", e);
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault()
        // Stash the event so it can be triggered later.
        this.setDeferredPrompt(e)
      })
    },
    setTabName() {
      document.title = this.brandConfig.gameTitle;
    },
    async setNewsFeed() {
      this.setIsLoading(true)
      this.setFeedArticles(await FantasyService.getNews());
      this.setIsLoading(false)
    }
  },
  beforeMount() {
    this.setNewsFeed();
    setBrandConfig();
    this.setTabName();
    this.captureEvent();
  }
}
</script>

<style lang="scss">
@import "../public/globalStyles/global";

.app-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100svh;
}

.vue-container {
  position: relative;
  font-family: 'Poppins', sans-serif;
  background-image: url("assets/backgrounds/bg-main.webp");
  background-size: cover;
  height: 100svh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

#ot-sdk-btn-floating.ot-floating-button {
  bottom: 50px !important;
  width: 30px !important;
  height: 30px !important;
}
</style>
